import { ChakraProvider } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AppError } from '~components/ui/AppError';
import { theme } from '~components/ui/styles/theme';
import ApolloProvider from '~graphql/ApolloProvider';
import { AnalyticsProvider } from '~utils/analytics';

interface Props {
  children: ReactNode;
}

function AppProvider({ children }: Props) {
  return (
    <ApolloProvider uri={process.env.REACT_APP_API_URI}>
      <ChakraProvider resetCSS theme={theme}>
        <HelmetProvider>
          <AnalyticsProvider>
            <Sentry.ErrorBoundary
              fallback={({ resetError }) => <AppError resetError={resetError} />}
            >
              {children}
            </Sentry.ErrorBoundary>
          </AnalyticsProvider>
        </HelmetProvider>
      </ChakraProvider>
    </ApolloProvider>
  );
}

export default AppProvider;
